
define(
	'Convergence.TopDealsExt.TopDealsExt'
,   [
		'Convergence.TopDealsExt.TopDealsExt.View'
	,	'Convergence.TopDealsExty.TopDealsExt.Collection'
	,	'AjaxRequestsKiller'
	]
,   function (
		TopDealsExtView
	,	TopDealsExtCollection
	,	AjaxRequestsKiller
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			
			if(layout)
			{
				
				layout.addChildView('Home.TopDeals.Slider', function() { 
					var collection = new TopDealsExtCollection();
					var view = new TopDealsExtView({ 
						container: container,
						collection: collection
					 });

					return view;
				
				})
				layout.on('afterShowContent', function() {
					
				})

			}

		}
	};
});
